import { Link } from "@mui/material";

import { FunctionComponent } from "react";

import { LinkedinIcon } from "@/components/LinkedinIcon/LinkedinIcon";
import { Tooltip } from "@/components/Tooltip/Tooltip";
import { InfoCardPopover, InfoCardPopoverRow } from "@/components/InfoCardPopover";
import { WebsiteIcon } from "@/components/WebsiteIcon/WebsiteIcon";
import { ListPerson } from "@/pages/Private/pages/List/schema/list";

import { ensureHttpProtocol } from "@/utils/url";
import { formatEmployees } from "@/pages/Private/pages/List/utils/column-utils";

export const OrgName: FunctionComponent<{
	row: ListPerson;
	// Hides the org LinkedIn icon (used where no LinkedIn URL is available, e.g. company-enrich previews).
	hideLinkedin?: boolean;
	// Compact lead card (PREC-3850): 12px type scale instead of the 14px list-card default.
	compact?: boolean;
}> = ({ row, hideLinkedin = false, compact = false }) => {
	return (
		<div className="flex flex-row gap-1 items-center w-full">
			<Tooltip
				className="flex-1 min-w-0"
				content={
					<InfoCardPopover
						kind="company"
						rows={
							[
								{ label: "Name", value: row.prospect?.organization?.name },
								{ label: "Location", value: row.prospect?.organization?.country },
								{
									label: "Employees",
									value: formatEmployees(
										row.prospect?.organization?.employeesFrom,
										row.prospect?.organization?.employeesTo
									),
								},
								{
									label: "Company category",
									value: row.prospect?.organization?.scoreCompanyCategoryResult?.result,
								},
								{
									label: "Company prio",
									value: row.prospect?.scorePersonaCategoryResult?.companyScore,
								},
								{
									label: "Short description",
									value: row.prospect?.organization?.shortDescription,
									long: true,
								},
							] satisfies InfoCardPopoverRow[]
						}
					/>
				}
			>
				<span
					className={`block w-full ${compact ? "text-xs" : "text-sm"} font-semibold truncate text-left rounded-[5px] px-[3px] py-[1px] -mx-[3px] -my-[1px] hover:bg-gray-50 transition-colors`}
				>
					{row.prospect?.organization?.name}
				</span>
			</Tooltip>
			{/* -mr-1 swallows the last icon's built-in mr-1 so the cluster ends flush at the row edge. */}
			<div className="flex flex-row gap-0 items-center shrink-0 -mr-1">
				{!hideLinkedin &&
					(row.prospect?.organization?.linkedinUrl ? (
						<Link
							href={ensureHttpProtocol(row.prospect?.organization?.linkedinUrl)}
							target="_blank"
						>
							<LinkedinIcon status="checked" />
						</Link>
					) : (
						row.prospect?.organization?.name && <LinkedinIcon status="failed" />
					))}
				{row.prospect?.organization?.websiteUrl ? (
					<Link href={ensureHttpProtocol(row.prospect?.organization?.websiteUrl)} target="_blank">
						<WebsiteIcon status="checked" />
					</Link>
				) : (
					<WebsiteIcon status="failed" />
				)}
			</div>
		</div>
	);
};
